import React from 'react'

// import ErrorIcon from 'assets/icons/error-icon.png'

import './widgetPaymentErrorStyles.css'

const WidgetPaymentError = ({ message }) => {
  return (
    <div className='widget-payment-error-container'>
      <div className='widget-payment-error-background' />
      <div className='widget-payment-warn-icon'>
        {/* <img src={ErrorIcon} alt='Error' /> */}
      </div>
      <p className='widget-payment-error-text'>
        {message || 'Payment wasn\'t succeed properly'}
      </p>
    </div>
  )
}

export default WidgetPaymentError
